import { createIcon } from "@chakra-ui/react";

const VeryHappy = createIcon({
  displayName: "VeryHappy",
  viewBox: "24 24 40 40",
  path: (
    <>
      <circle cx="44" cy="44" r="20" fill="currentColor" />
      <path d="M57 41.46a.31.31 0 0 0 .47-.26 2.6 2.6 0 1 0-5.2 0 .31.31 0 0 0 .47.26 4.05 4.05 0 0 1 4.25 0zM35.25 41.46a.31.31 0 0 0 .47-.26 2.6 2.6 0 0 0-5.2 0 .31.31 0 0 0 .47.26 4.05 4.05 0 0 1 4.25 0zM33.94 47a1.17 1.17 0 0 0-.74 1.51c1.47 3.69 5.8 6.82 10.8 6.82s9.34-3.12 10.8-6.83a1.17 1.17 0 0 0-.74-1.5 33.58 33.58 0 0 0-20.12 0z" />
      <path
        d="M38.59 54.06a12.17 12.17 0 0 0 10.82 0 9 9 0 0 0-10.82 0z"
        fill="#c4c4c4"
      />
    </>
  )
});

export default VeryHappy;
